import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Fonts } from '../Label.h'

export interface ILabelInlineSecondaryTemplateProps extends ILabelProps {}

export const LabelInlineSecondaryTemplate = ({
  title = '',
  color = COLOR.TEXT_ICON_SECONDARY,
  font = Fonts.FontXs,
  ...rest
}: ILabelInlineSecondaryTemplateProps): JSX.Element => (
  <Label title={title} color={color} font={font} {...rest} />
)
